import ol from 'openlayers';

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

import EditIcon from '@material-ui/icons/Edit';
import LocationIcon from '@material-ui/icons/MyLocation';
import PhoneIcon from '@material-ui/icons/Phone';
import PublicIcon from '@material-ui/icons/Public';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PersonIcon from '@material-ui/icons/Person';
import SaveIcon from '@material-ui/icons/Done';
import DiscardIcon from '@material-ui/icons/Close';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Collapse from '@material-ui/core/Collapse';

import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import SelectWrapped from './MultiselectComponent';
import Tooltip from '@material-ui/core/Tooltip';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import AddressPicker from './AddressPickerComponent';

import 'font-awesome/css/font-awesome.min.css';
import './featureEditor.css';
import './lib/common';
import { putData } from './lib/common';

const spinnerStyles = {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '50%',
    marginBottom: '50%',
}
const panelStyles = {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto'
}


class ListEditableItem extends Component {
    state = {}

    componentDidMount() {
        const { FIELDS_SCHEMA } = this.props
        this.setState({FIELDS_SCHEMA: FIELDS_SCHEMA})
    }

    componentDidUpdate() {
        const {editing, field, onEditModeChange} = this.props
        if (editing && field == 'address') {
            onEditModeChange(true)
        }
    }

    fieldType() {
        const { field, isSpecialField, place } = this.props;
        if (isSpecialField) {
            return this.state.FIELDS_SCHEMA[place['building_type']].fields[field].type;
        } else {
            return this.state.FIELDS_SCHEMA.default.fields[field].type;
        }
    }

    setAddress(address, point) {
        this.setState({editedValue: {address: address, point: point}})
    }

    editorForType() {
        const { place, field, classes, multiselect_options, isSpecialField } = this.props;
        const
            fieldType = this.fieldType(),
            currentFieldValue = isSpecialField ? place['special_fields'][field] : place[field];

        if (!this.state.editedValue && !(this.state.editedValue == '') && currentFieldValue)
            this.setState({editedValue: currentFieldValue})
        
        if (field == 'address' && !isSpecialField) {
            return <AddressPicker
                defaultValue={currentFieldValue}
                onChange={(value) => {
                    if (value) {
                        const {address, point} = value;
                        place.geometry.setCoordinates(ol.proj.transform(point, 'EPSG:4326', 'EPSG:3857'))
                        this.setAddress(address, null)
                    }
                }}
                onSelect={(value) => {
                    if (value && value.address && value.point) {
                        place.geometry.setCoordinates(ol.proj.transform(value.point, 'EPSG:4326', 'EPSG:3857'))
                        this.setAddress(value.address, null)
                    } else if (value && value.address && !value.point) {
                        this.setAddress(value.address, null);
                    }
                }}
            />
        }

        if ( fieldType == 'text' || fieldType == 'array') {
            return <TextField
                value={this.state.editedValue}
                onChange={(e) => {this.setState({editedValue: e.target.value})}}
            />
        } else if (
            fieldType == 'multiselect' || 
            fieldType == 'select' ||
            fieldType == 'boolean-select'
        ) {
            return <Input
              fullWidth
              inputComponent={SelectWrapped}
              value={this.state.editedValue}
              onChange={(v) => {this.setState({editedValue: v})}}
              placeholder="Начните набирать"
              name="react-select-chip-section"
              inputProps={{
                classes,
                multi: (fieldType == 'multiselect'),
                instanceId: 'react-select-chip-section',
                id: 'react-select-chip-section',
                simpleValue: true,
                options: Object.keys(multiselect_options).map(
                    t => ({
                      value: t,
                      label: multiselect_options[t],
                    })
                ),
              }}
            />
        } else if (fieldType == 'date') {
            return <TextField
                id="date"
                label=""
                type="date"
                value={this.state.editedValue}
                onChange={(v) => { console.log(v.target.value); this.setState({editedValue: v.target.value})}}
                inputProps={{
                    formatDate: (date) => 
                    date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear() 
                }}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        }
        else {
            return null
        }
    }

    onSave() {
        const { onSaveClick, field, onEditModeChange, isSpecialField } = this.props;
        const fieldType = this.fieldType();
        if (field == 'address' && !isSpecialField) {
            onSaveClick(typeof(this.state.editedValue) === 'string' ? {'address': this.state.editedValue} : this.state.editedValue)
            onEditModeChange(false)
            return;
        }
        if ( fieldType == 'text' || fieldType == 'select' || fieldType == 'multiselect' || fieldType == 'array' || fieldType == 'date' ) {
            onSaveClick(this.state.editedValue)
        } else if (fieldType == 'select') {
            onSaveClick(this.state.editedValue === '' ? null : this.state.editedValue)
        } else if (fieldType == 'boolean-select') {
            let booleanCasted = null;
            if (this.state.editedValue == 'true') {
                booleanCasted = true
            } else if (this.state.editedValue == 'false') {
                booleanCasted = false
            }
            onSaveClick(booleanCasted)
        }
    }

    onDiscard() {
        const { field, onDiscardClick, onEditModeChange, isSpecialField } = this.props
        this.setState({editedValue: null})
        onDiscardClick()
        if (field == 'address' && !isSpecialField) {
            onEditModeChange(false)
        }
    }

    render() {
        const { field, textFunction=((t)=>(<Typography>{t}</Typography>)), icon, inset, placeholder, onEditClick,
            editing, place, isSpecialField, authorizedUser } = this.props

        const
            currentFieldValue = isSpecialField ? place['special_fields'][field] : place[field],
            primaryListItemText = editing ? this.editorForType() : textFunction(currentFieldValue);

        return (
            <ListItem style={{paddingTop: '0.25em', paddingBottom: '0.5em'}}>
                {icon ? 
                    <ListItemIcon>
                        {icon}
                    </ListItemIcon> : null
                }
                <ListItemText
                    primary={
                        primaryListItemText
                    }
                    secondary={
                        placeholder //TODO: fix
                    }
                    inset={inset}
                />
                {
                    authorizedUser && 
                    (
                        authorizedUser.roles.includes('admin') ||
                        (
                            authorizedUser.city === place.city && 
                            authorizedUser.roles.includes('user')
                        ) || 
                        (
                            authorizedUser.roles.includes('single_object_user') &&
                            authorizedUser.objectIds.includes(place.id)
                        )
                    ) ?
                    <ListItemSecondaryAction>
                        {editing ?
                            <div style={{display: 'flex', 'flexDirection': 'column'}}>
                                <Tooltip id="tooltip-search" title="Сохранить" placement='right'>
                                    <IconButton aria-label="Save" onClick={
                                        () => this.onSave()
                                    }>
                                        <SaveIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip id="tooltip-search" title="Отмена" placement='right'>
                                    <IconButton aria-label="Discard" onClick={
                                        () => this.onDiscard()
                                    }>
                                        <DiscardIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            :
                            <Tooltip id="tooltip-search" title="Редактировать" placement='right'>
                                <IconButton aria-label="Edit" onClick={onEditClick}>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        }
                    </ListItemSecondaryAction> 
                    : null
            }
            </ListItem>
        )
    }
}

class FeatureEditorComponent extends Component {
    selectedIndex = null
    selectedPlace = null
    featureProperties = {}
    state = {displayEditIcon: null}

    async componentWillMount() {
        let resp = await fetch('/api/metadata?cities&fields_schema', {credentials: 'include'})
        let data = await resp.json()
        this.setState({
            CITIES: data['cities'],
            FIELDS_SCHEMA: data['fields_schema']
        })
    }

    saveSimpleField (field, newValue) {
        const { onLoading } = this.props
        let request = {}
        request[field] = newValue === '' ? null : newValue;
        onLoading(true)
        putData(
            '/api/features/' + this.selectedPlace.id,
            request
        ).then(
            id => {
                this.selectedPlace[field] = newValue;
                this.setState(this.state)
                
                console.log('successfully edited ' + id);
            }
        ).catch(
            error => console.log(error)
        ).finally(
            () => {
                onLoading(false)
            }
        )
    }

    saveSpecialField (field, newValue) {
        let preparedValue = {};
        preparedValue[field] = newValue;
        this.saveSimpleField('special_fields', preparedValue)
    }

    onDeleteClick () {
        const {deleteFeature, selected} = this.props
        this.saveSimpleField('deleted', true)
        deleteFeature(selected)
    }

    editableListItemFabric(field, placeholder, textFunction, inset=false, multiselect_options=null, isSpecialField=false) {
        const {classes, onEditModeChange, selected, saveFeatureGeom, authorizedUser} = this.props
        const fieldIcons = {
            'name': null,
            'description': null,
            'address': <LocationIcon />,
            'phone': <PhoneIcon />,
            'url': <PublicIcon />,
            'mail': <MailOutlineIcon />,
            'administrator': <PersonIcon />
        };

        if (isSpecialField) {
            if (this.selectedPlace['special_fields'] === null || this.selectedPlace['special_fields'] === undefined) {
                this.selectedPlace['special_fields'] = {}
            }
            if (!(field in this.selectedPlace['special_fields'])) {
                this.selectedPlace['special_fields'][field] = null;
            }
        }

        const 
            fieldType = this.state.FIELDS_SCHEMA[
                isSpecialField ? this.selectedPlace['building_type'] : 'default'
            ].fields[field].type,
            saveField = isSpecialField ? (f, v) => this.saveSpecialField(f, v) : (f, v) => this.saveSimpleField(f, v),
            currentFieldValue = isSpecialField ? this.selectedPlace['special_fields'][field] : this.selectedPlace[field];

        //TODO: array is hacked now
        if (fieldType == 'text' || 
            fieldType == 'array') {
            return <ListEditableItem
                field={field}
                place={this.selectedPlace}
                textFunction={textFunction}
                placeholder={placeholder}
                onEditClick={()=>this.setState({currentlyEditedField: field})}
                onDiscardClick={()=>this.setState({currentlyEditedField: null})}
                onSaveClick={(newValue)=>{
                    
                    this.setState({currentlyEditedField: null});
                    
                    if (field == 'address' && !isSpecialField) {
                        this.saveSimpleField(field, newValue.address);
                        console.log(this.selectedPlace.geometry.getCoordinates())
                        if (newValue.point) {
                            saveFeatureGeom(selected, 'place')
                        } else {
                            saveFeatureGeom(selected, 'cluster')
                        }
                    } else {
                        saveField(field, newValue)
                    }
                }}
                editing={this.state.currentlyEditedField == field}
                inset={inset}
                icon={fieldIcons[field] || null}
                FIELDS_SCHEMA={this.state.FIELDS_SCHEMA}
                onEditModeChange={onEditModeChange}
                isSpecialField={isSpecialField}
                authorizedUser={authorizedUser}
            />
        } else if (
            fieldType == 'multiselect' || 
            fieldType == 'select' ||
            fieldType == 'boolean-select'
        ) {
            const isMulti = fieldType == 'multiselect'
            return <ListEditableItem
                field={field}
                place={this.selectedPlace}
                textFunction={(text) => textFunction(<Input
                  fullWidth
                  inputComponent={SelectWrapped}
                  value={currentFieldValue}
                  name="react-select-chip-section"
                  placeholder='Нет информации'
                  inputProps={{
                    classes,
                    multi: isMulti,
                    instanceId: 'react-select-chip-section',
                    id: 'react-select-chip-section',
                    simpleValue: true,
                    options: Object.keys(multiselect_options).map(
                        t => ({
                          value: t,
                          label: multiselect_options[t],
                        })
                    ),
                    disabled: true
                  }}
                />)}
                placeholder={placeholder}
                onEditClick={()=>this.setState({currentlyEditedField: field})}
                onDiscardClick={()=>this.setState({currentlyEditedField: null})}
                onSaveClick={(newValue)=>{
                    this.setState({currentlyEditedField: null});
                    console.log(newValue);
                    console.log(newValue == ['']);
                    console.log(newValue === null)
                    console.log(newValue)
                    if (isMulti) {
                        // TODO: fixme - multiselect with empty values not working
                        const preparedValue = (
                            !newValue 
                            || (
                                newValue 
                                && (
                                    (newValue.length === 1 && newValue[0] === '')
                                    || (newValue.length === 0)
                                )
                            )
                        ) ? null : newValue.split(',');
                        saveField(field, preparedValue);
                    } else {
                        saveField(field, newValue)
                    }
                }}
                editing={this.state.currentlyEditedField == field}
                inset={inset}
                icon={fieldIcons[field] || null}
                multiselect_options={multiselect_options}
                FIELDS_SCHEMA={this.state.FIELDS_SCHEMA}
                isSpecialField={isSpecialField}
                authorizedUser={authorizedUser}
            />
        } else if (fieldType == 'date') {
            return <ListEditableItem
                field={field}
                place={this.selectedPlace}
                textFunction={_ =>
                    <TextField
                        id="date"
                        label=""
                        type="date"
                        defaultValue={currentFieldValue}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        disabled={true}
                    />
                }
                placeholder={placeholder}
                onEditClick={()=>this.setState({currentlyEditedField: field})}
                onDiscardClick={()=>this.setState({currentlyEditedField: null})}
                onSaveClick={(newValue)=>{
                    this.setState({currentlyEditedField: null});
                    saveField(field, newValue);
                }}
                editing={this.state.currentlyEditedField == field}
                inset={inset}
                icon={fieldIcons[field] || null}
                FIELDS_SCHEMA={this.state.FIELDS_SCHEMA}
                isSpecialField={isSpecialField}
                authorizedUser={authorizedUser}
            />
        }
    }

    renderSpecialFields() {
        if (this.selectedPlace.building_type in this.state.FIELDS_SCHEMA) {
            return Object.keys(this.state.FIELDS_SCHEMA[this.selectedPlace.building_type].fields).map(
                field => {
                    const fieldObject = this.state.FIELDS_SCHEMA[this.selectedPlace.building_type].fields[field];
                    console.log('rendering special field: ' + field)
                    return this.editableListItemFabric(
                        field,
                        fieldObject.label,
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        false,
                        fieldObject.options,
                        true
                    )
                }
            )
        }
    }

    componentWillUpdate(nextProps) {
        const {places, selected} = nextProps
        const foundIndex = places.findIndex(place => place.id === selected)
        this.selectedIndex = foundIndex == -1 ? null : foundIndex
        this.selectedPlace = places[this.selectedIndex] || {}
    }

    componentDidUpdate() {
        const {savePlaceOrCluster, saveFeatureGeom} = this.props

        if (savePlaceOrCluster === 'done' && this.selectedPlace && 'geometry' in this.selectedPlace) {
            console.log('updating editor')
            console.log(this.selectedPlace)
            const newPoint = ol.proj.transform(this.selectedPlace.geometry.getCoordinates(), 'EPSG:3857', 'EPSG:4326')
            
            console.log('saving ' + newPoint)
            
            this.saveSimpleField('geodata', {'coords': newPoint});
            
            saveFeatureGeom(null, null)
        }
    }

    render () {
        const {
            places, selected,
            isWaitingForResponse, classes, isPanelOpened,
            openPanel, doHidePopup, authorizedUser
        } = this.props
        const foundIndex = places.findIndex(place => place.id === selected)
        this.selectedIndex = foundIndex == -1 ? null : foundIndex
        this.selectedPlace = places[this.selectedIndex] || {}

        if (isWaitingForResponse){
            return (
                <CircularProgress size={100} className={classes.progress} style={spinnerStyles}/>
            )
        }
        return (
            (this.selectedPlace && selected && isPanelOpened) ?
            <div style={panelStyles}>
                <List component="nav">
                    {this.editableListItemFabric(
                        'name',
                        'Название',
                        (text) =>
                            (<Typography variant='subheading' >
                                {text}
                            </Typography>)
                    )}
                    {this.editableListItemFabric(
                        'description',
                        'Описание',
                        (text) =>
                            (<Typography color='textSecondary'>
                                {text}
                            </Typography>)
                    )}
                 </List>

                <Divider />

                <List component="nav">
                    {this.editableListItemFabric(
                        'building_type',
                        'Тип по деятельности',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        false,
                        this.state.FIELDS_SCHEMA.default.fields.building_type.options
                    )}
                    {this.editableListItemFabric(
                        'address',
                        'Адрес',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        true
                    )}
                    {this.editableListItemFabric(
                        'city',
                        'Городской округ',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        true,
                        this.state.CITIES.map(x=>{let a = {}; a[x] = x; return a}).reduce((a, c) => {return {...a, ...c}}, {})
                    )}
                    {this.editableListItemFabric(
                        'phone',
                        'Телефон',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        true
                    )}
                    {this.editableListItemFabric(
                        'url',
                        'Сайт',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        true
                    )}
                    {this.editableListItemFabric(
                        'accessibility',
                        'Доступность для маломобильных групп населения',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        false,
                        this.state.FIELDS_SCHEMA.default.fields.accessibility.options
                    )}
                    {this.editableListItemFabric(
                        'accessibility_categories',
                        'Категории по видам доступности',
                        (text) =>
                            (<Typography >
                                {text}
                            </Typography>),
                        false,
                        this.state.FIELDS_SCHEMA.default.fields.accessibility_categories.options
                    )}
                    <ListItem button onClick={
                        () => this.setState({ detailsExpanded: !this.state.detailsExpanded })
                    }>
                        <ListItemText inset primary="Подробнее" />
                        {this.state.detailsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </ListItem>
                    <Collapse in={this.state.detailsExpanded || authorizedUser } timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {this.editableListItemFabric(
                                'sections',
                                'Секции',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                false,
                                this.state.FIELDS_SCHEMA.default.fields.sections.options
                            )}

                            {this.renderSpecialFields()}

                            {authorizedUser ? this.editableListItemFabric(
                                'owner',
                                'Форма собственности',
                                (text) => (<Typography >
                                        {text}
                                    </Typography>),
                                false,
                                this.state.FIELDS_SCHEMA.default.fields.owner.options
                            ) : null}
                            {this.editableListItemFabric(
                                'mail',
                                'E-mail',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                true
                            )}
                            {this.editableListItemFabric(
                                'administrator',
                                'Руководитель',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                true
                            )}
                            {authorizedUser ? this.editableListItemFabric(
                                'construction_date',
                                'Дата постройки',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                false
                            ) : null}
                            {authorizedUser ? this.editableListItemFabric(
                                'is_registered',
                                'Регистрация во Всероссийском реестре спортивных сооружений',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                false,
                                this.state.FIELDS_SCHEMA.default.fields.is_registered.options
                            ) : null}
                            {(authorizedUser && this.selectedPlace['is_registered']) ?
                                <div>
                                    {
                                        this.editableListItemFabric(
                                            'registration_date',
                                            'Дата регистрации',
                                            (text) =>
                                                (<Typography >
                                                    {text}
                                                </Typography>),
                                            false
                                        )
                                    }
                                    {   this.editableListItemFabric(
                                            'has_medic',
                                            'Наличие медицинского кабинета',
                                            (text) =>
                                                (<Typography >
                                                    {text}
                                                </Typography>),
                                            false,
                                            this.state.FIELDS_SCHEMA.default.fields.has_medic.options
                                        )
                                    }
                                    {   this.editableListItemFabric(
                                            'registration_category',
                                            'Категория',
                                            (text) =>
                                                (<Typography >
                                                    {text}
                                                </Typography>),
                                            false,
                                            this.state.FIELDS_SCHEMA.default.fields.registration_category.options
                                        )
                                    }
                                </div>
                            : 
                            <div>
                                { authorizedUser ?
                                    this.editableListItemFabric(
                                        'is_registration_applied',
                                        'Заявка на регистрацию',
                                        (text) =>
                                                (<Typography >
                                                    {text}
                                                </Typography>),
                                        false,
                                        this.state.FIELDS_SCHEMA.default.fields.is_registration_applied.options
                                    )
                                    : null
                                }
                                {(authorizedUser && this.selectedPlace['is_registration_applied']) ?
                                    <div>
                                        {
                                            this.editableListItemFabric(
                                                'application_date',
                                                'Дата подачи заявки',
                                                (text) =>
                                                    (<Typography >
                                                        {text}
                                                    </Typography>),
                                                false
                                            )
                                        }
                                        {
                                            this.editableListItemFabric(
                                                'application_result',
                                                'Результат рассмотрения заявки',
                                                (text) =>
                                                    (<Typography >
                                                        {text}
                                                    </Typography>),
                                                false
                                            )
                                        }
                                    </div> 
                                    : null
                                }
                            </div>
                        }
                        { authorizedUser ?
                            this.editableListItemFabric(
                                'reconstruction_type',
                                'Реконструкция/капитальный ремонт',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                false,
                                this.state.FIELDS_SCHEMA.default.fields.reconstruction_type.options
                            )
                            : null
                        }
                        {(authorizedUser && this.selectedPlace['reconstruction_type']) ?
                            <div>{
                                this.editableListItemFabric(
                                    'reconstruction_date',
                                    'Дата проведения ремонта/реконструкции',
                                    (text) =>
                                        (<Typography >
                                            {text}
                                        </Typography>),
                                    false
                                )
                            }</div> : null
                        }
                        {authorizedUser ?
                            this.editableListItemFabric(
                                'tour',
                                'URL виртуального тура',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>
                                )
                            )
                            : null
                        }
                        {authorizedUser ?
                            this.editableListItemFabric(
                                'is_public',
                                'Опубликован для неавторизованного доступа',
                                (text) =>
                                    (<Typography >
                                        {text}
                                    </Typography>),
                                false,
                                this.state.FIELDS_SCHEMA.default.fields.is_public.options
                            )
                            : null
                        }
                        {authorizedUser && authorizedUser.roles.includes('admin') ?
                            <Typography align='center'>
                                <Button 
                                    onClick={() => this.setState({showDeleteDialog: true, currentlyEditedField: null})}
                                    variant='contained'
                                    color='secondary'
                                >
                                    Удалить объект навсегда без возможности восстановления
                                </Button>
                            </Typography>
                            : null
                            }
                        </List>
                    </Collapse>
                </List>
                <Dialog
                  open={this.state.showDeleteDialog}
                  onClose={() => this.setState({showDeleteDialog: false})}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  style={{zIndex: 20000}}
                >
                  <DialogTitle id="alert-dialog-title">{"Удалить объект?"}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Если вы хотите удалить объект, введите в поле ниже следующий текст: <b>{selected}</b>
                    </DialogContentText>
                    <TextField
                        value={this.state.deleteCaptcha}
                        onChange={(v) => {this.setState({deleteCaptcha: v.target.value})}}
                        error={this.state.deleteCaptchaError || false}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => this.setState({showDeleteDialog: false})} color="primary" autoFocus>
                      Отмена
                    </Button>
                    <Button onClick={() => {
                        if (this.state.deleteCaptcha == selected) {
                            this.onDeleteClick();
                            this.setState({
                                deleteCaptchaError: false,
                                showDeleteDialog: false
                            });
                            openPanel(false);
                            doHidePopup(true);
                        } else {
                            this.setState({deleteCaptchaError: true})
                        }
                    }}
                    color="secondary">
                      Удалить
                    </Button>
                  </DialogActions>
                </Dialog>
            </div>
            : <div></div>
        )
    }
}

export default withStyles()(FeatureEditorComponent)



// WEBPACK FOOTER //
// ./src/FeatureEditorComponent.js